import { ANALYTICS_SEGMENT } from 'Constants/analytics';
import segmentClient from 'Utilities/analytics/segmentClient';
let _analyticsClient;
export const initialize = config => {
  if (!config || config.driver === '' || config.driver === 'none') {
    return;
  }
  const analyticsType = config.driver;
  if (analyticsType === ANALYTICS_SEGMENT) {
    _analyticsClient = segmentClient;
    _analyticsClient.initialize(config.configuration);
  }
};